import {
  CarouselSkeletonWrapper,
  CarouselSkeletonText,
  CarouselSkeletonCards,
  CarouselSkeletonCard,
  CarouselSkeletonDots,
  FlexContainer,
} from './BestOfComponentSkeleton.styles';

export const SkeletonCarouselLoader: React.FC = () => {
  return (
    <CarouselSkeletonWrapper>
      <FlexContainer>
        <div className="carousel-title"></div>
        <div className="carousel-cta"></div>
      </FlexContainer>

      <CarouselSkeletonText>
        <div className="line desc-main"></div>
        <div className="line desc-sub"></div>
      </CarouselSkeletonText>

      <CarouselSkeletonCards>
        <CarouselSkeletonCard />
        <CarouselSkeletonCard />
      </CarouselSkeletonCards>

      <CarouselSkeletonDots>
        <span className="dot active"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </CarouselSkeletonDots>
    </CarouselSkeletonWrapper>
  );
};
